import { css } from "@emotion/react";

import * as ui from "../../ui";

export const footer = css`
  align-self: flex-end;
  margin-top: auto;
  ${ui.row("xs")};
`;

export const footerButton = (active: boolean) => css`
  font-style: normal;
  font-weight: 500;
  font-size: ${ui.rem(16)};
  line-height: ${ui.rem(22)};
  text-align: center;
  color: #545454;
  background-color: white;
  transition: box-shadow 300ms;
  padding: ${ui.rem("xs")} ${ui.rem("sm")};
  border: 1px solid #000000;

  ${active
    ? `
cursor:pointer;
:hover {
    box-shadow: 1px ${ui.rem(2)} ${ui.rem(2)} #a1a1a1;
}

`
    : "opacity: 0.2;"}
`;

export const footerPage = css`
  font-style: normal;
  font-weight: 500;
  font-size: ${ui.rem(16)};
  line-height: ${ui.rem(22)};
  text-align: center;
  color: #ffffff;
  background-color: #444444;

  padding: ${ui.rem("xs")} ${ui.rem("sm")};
  border: 1px solid #000000;
`;
